import { Chip } from '@ds';
import { isNil } from 'lodash-es';
import SectionRow from '@features/components/CaseOverview/components/SectionRow/SectionRow';
import { nrpTypes } from '@/constants/case/case.constants';
import { formatTimeDifference, getClinicalRecordByType, yesNo } from '@/utils/helpers';
import { ClinicalData, ClinicalItemType } from '@/api/apis/case';

export const NrpChips = ({ clinicalData }: { clinicalData?: ClinicalData }) => {
  if (!clinicalData) return null;

  const nrpItem = getClinicalRecordByType(clinicalData, ClinicalItemType.NRPApplicabilityAndType)?.item;
  const nrpTimerItem = getClinicalRecordByType(clinicalData, ClinicalItemType.NRPStart)?.item;
  const nrpTimerItemEnd = getClinicalRecordByType(clinicalData, ClinicalItemType.CrossClampTimeFlushTime)?.item;
  const nrpTimerEndDate = nrpTimerItemEnd ? new Date(nrpTimerItemEnd.timestamp) : new Date();
  const nrp = nrpItem?.yesNo;
  const nrpType = nrpItem?.nrpType;

  return (
    <SectionRow label="NRP">
      <div className="flex gap-1 items-center">
        <Chip size="sm">{isNil(nrpItem) ? 'Not Selected' : yesNo(nrp)}</Chip>
        {nrp && (
          <div className="flex gap-8 items-center">
            {nrpType && <Chip size="sm">{nrpTypes[nrpType]}</Chip>}
            {nrpTimerItem && (
              <Chip className="bg-danger-70 text-danger-10 h-5" size="sm">
                {formatTimeDifference(new Date(nrpTimerItem.timestamp), nrpTimerEndDate)}
              </Chip>
            )}
          </div>
        )}
      </div>
    </SectionRow>
  );
};
